document.addEventListener('DOMContentLoaded', () => {
  const PHASE_DURATION = [3000, 3400, 3400, 3200];
  const STATIC_PHASE = 2;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canObserve = 'IntersectionObserver' in window;

  const initReveal = (root) => {
    if (!canObserve || reducedMotion.matches) return;

    root.classList.add('is-reveal-ready');
    const observer = new IntersectionObserver((entries) => {
      for (const { isIntersecting, target } of entries) {
        if (!isIntersecting) continue;
        target.classList.add('is-visible');
        observer.unobserve(target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -10px 0px' });

    for (const item of root.querySelectorAll('[data-ppa-reveal]')) observer.observe(item);
  };

  const initDemo = (demo) => {
    const toggle = demo.querySelector('[data-ppa-demo-toggle]');
    let phase = 0;
    let timer = null;
    let visible = !canObserve;
    let userPaused = false;

    const setPhase = (next) => {
      phase = next;
      demo.dataset.phase = String(next);
    };

    const stop = () => {
      clearTimeout(timer);
      timer = null;
    };

    const play = () => {
      stop();
      if (!visible || userPaused || reducedMotion.matches || document.hidden) return;

      timer = setTimeout(() => {
        setPhase((phase + 1) % PHASE_DURATION.length);
        play();
      }, PHASE_DURATION[phase]);
    };

    const applyMotionPreference = () => {
      stop();
      setPhase(reducedMotion.matches ? STATIC_PHASE : 0);
      play();
    };

    toggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      toggle.setAttribute('aria-pressed', String(userPaused));
      play();
    });

    if (canObserve) {
      new IntersectionObserver((entries) => {
        for (const { isIntersecting } of entries) {
          visible = isIntersecting;
          play();
        }
      }, { threshold: 0.25 }).observe(demo);
    }

    document.addEventListener('visibilitychange', play);
    reducedMotion.addEventListener('change', applyMotionPreference);
    applyMotionPreference();
  };

  for (const root of document.querySelectorAll('[data-ppa-mechanism]')) {
    initReveal(root);
    const demo = root.querySelector('[data-ppa-demo]');
    if (demo) initDemo(demo);
  }
});
